import { Outlet, createFileRoute } from "@tanstack/react-router";
import { Layout } from "antd";
import i18next from "i18next";
import { useEffect } from "react";

const { Content } = Layout;

export const Route = createFileRoute("/$tenantSlug/processes/_layout")({
    component: ProcessLayoutComponent,
});

function ProcessLayoutComponent() {
    useEffect(() => {
        i18next.changeLanguage("cs");
    }, []);

    return (
        <Layout className={"bg-[#000000] overflow-y-scroll"}>
            <Content className={"m-5"}>
                <div className="flex flex-1 justify-center items-center h-full">
                    <main className="">
                        <Outlet />
                    </main>
                </div>
            </Content>
        </Layout>
    );
}
